import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSiteLang as useLang } from '../siteLang';

const T = {
    fr: {
        eyebrow: 'winston.ie',
        lead: "Cette page s'est perdue quelque part entre deux archives.",
        sub: 'Elle a peut-être été déplacée ou supprimée.',
        cta: "← Retour à l'accueil",
    },
    en: {
        eyebrow: 'winston.ie',
        lead: 'This page got lost somewhere between two archives.',
        sub: 'It may have been moved or deleted.',
        cta: '← Back to home',
    },
    vi: {
        eyebrow: 'winston.ie',
        lead: 'Trang này đã bị lạc đâu đó giữa hai kho lưu trữ.',
        sub: 'Nó có thể đã bị di chuyển hoặc xóa.',
        cta: '← Về trang chủ',
    },
};

export default function NotFound() {
    const navigate = useNavigate();
    const { lang } = useLang();
    const t = T[lang] || T.fr;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', background: '#ffffff', fontFamily: "'Helvetica Neue', Arial, sans-serif" }}>
            <Navbar variant="light" />

            <style>{`
                @keyframes notfoundFloat {
                    0%, 100% { transform: rotate(-6deg) translateY(0); }
                    50% { transform: rotate(-6deg) translateY(-14px); }
                }
                .notfound-smiley { animation: notfoundFloat 5s ease-in-out infinite; }
            `}</style>

            <div style={{
                flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                padding: 'clamp(64px, 12vw, 120px) 24px', textAlign: 'center',
            }}>
                <p style={{
                    fontFamily: 'Helvetica Neue, Arial, sans-serif', fontWeight: 700, fontSize: '10px',
                    letterSpacing: '0.24em', textTransform: 'uppercase', color: 'rgba(14,16,19,0.4)',
                    margin: '0 0 20px',
                }}>
                    {t.eyebrow}
                </p>

                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 'clamp(12px, 3vw, 28px)', marginBottom: '36px' }}>
                    <span style={{
                        fontFamily: 'Helvetica Neue, Arial, sans-serif', fontWeight: 700,
                        fontSize: 'clamp(84px, 20vw, 200px)', letterSpacing: '-0.04em',
                        color: '#0e1013', lineHeight: 1,
                    }}>
                        404
                    </span>
                    <img
                        src="/winston-smiley-white.svg"
                        alt="winston.ie"
                        className="notfound-smiley"
                        style={{ height: 'clamp(48px, 10vw, 96px)', width: 'auto', filter: 'invert(1)' }}
                    />
                </div>

                <p style={{ fontSize: '15px', fontWeight: '500', color: '#333', margin: '0 0 8px', maxWidth: '420px' }}>
                    {t.lead}
                </p>
                <p style={{ fontSize: '12.5px', fontWeight: '500', color: '#999', margin: '0 0 36px' }}>
                    {t.sub}
                </p>

                <button
                    onClick={() => navigate('/')}
                    className="wlink"
                    style={{
                        background: 'none', border: 'none', padding: 0, color: '#0e1013',
                        fontSize: '12.5px', fontWeight: '700', letterSpacing: '0.02em', cursor: 'pointer',
                        fontFamily: "'Helvetica Neue', Arial, sans-serif",
                    }}
                >
                    {t.cta}
                </button>
            </div>

            <Footer variant="light" />
        </div>
    );
}